import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import css from '@src/styles/components/rating.scss';

export default class Rating extends React.Component {

    static get propTypes() {

        return {
            className: PropTypes.string,
            value: PropTypes.number,
            max: PropTypes.number,
            count: PropTypes.number,
            label: PropTypes.string,
            link: PropTypes.string,
        };
    }

    render() {

        if (!this.props.value)
            return null;

        const
            roundedValue = this.getRoundedValue(),
            items = Array(this.getMax())
                .fill(null)
                .map((el, i) => <i key={ i } className={ `${style('icon-star')} ${(i + 1) <= roundedValue ? css.active : ''}` }></i>);

        return (
            <div className={ `${css.rating} ${this.props.className ?? ''}` }>

                {/* stars */}
                <div className={ css.ratingItems }>
                    { items }
                </div>

                {/* rating value */}
                <div className={ style('text-medium desktop:ml-1') }>{ this.props.value }</div>

                {/* reviews count */}
                { this.getHtmlCount() }

            </div>
        );
    }

    getHtmlCount() {

        return this.props.count
            ? <div className={ style('text-muted') }>({ this.props.count })</div>
            : null;
    }

    getMax() {

        return this.props.max ?? 5;
    }

    getRoundedValue() {

        return Math.floor(this.props.value);
    }

}